export const getOfflineAccessFieldConfig = ({ isEligible }) => ({
  offlineModeAccess: {
    '#isDisabled': !isEligible,
    '#isVisible': isEligible ? 'isVisible' : 'isNotVisible',
  },
});

export const getMfaFieldConfig = ({ offlineModeAccessValue }) => ({
  roleFormDataPatch: {
    mfa: {
      '#isDisabled': offlineModeAccessValue === true,
    },
  },
  roleFormStatePatch: {
    mfa: {
      value: offlineModeAccessValue === true ? false : true,
    },
  },
});

export const getHprFieldModeConfig = ({ mode }) => {
  if (mode === 'abha-only') {
    return {
      hpr_id: {
        '#type': 'verifyHPR',
        '#isDisabled': true,
        '#title': 'ABHA Number',
        '#webform_key': 'abha_id',
        '#required': true,
      },
      user_status: {
        '#isDisabled': true,
        '#required': true,
      },
    };
  }

  if (mode === 'hpr-required') {
    return {
      hpr_id: {
        '#type': 'verifyHPR',
        '#isDisabled': false,
        '#title': 'HPR ID',
        '#webform_key': 'hpr_id',
        '#required': true,
      },
      user_status: {
        '#isDisabled': true,
        '#required': true,
      },
    };
  }

  if (mode === 'hpr-optional') {
    return {
      hpr_id: {
        '#type': 'verifyHPR',
        '#isDisabled': true,
        '#title': 'HPR ID',
        '#webform_key': 'hpr_id',
        '#required': true,
      },
      user_status: {
        '#isDisabled': false,
        '#required': true,
      },
    };
  }

  return {
    hpr_id: {
      '#webform_key': 'hpr_id',
      '#required': true,
      '#isDisabled': true,
      '#type': 'verifyHPR',
      '#title': 'HPR ID/ABHA Number',
    },
  };
};

export const getResetHprFieldPatch = () => ({
  hpr_id: {
    value: '',
    id: 0,
    code: 0,
    isError: false,
    message: '',
  },
});

export const getVerificationResultConfig = ({ isVerified, isAbhaFlow, hfrAbhaId }) => {
  if (isVerified === 'true') {
    return {
      formStatePatch: isAbhaFlow
        ? {
            user_status: { value: true },
            abha_id: { value: hfrAbhaId },
          }
        : {
            user_status: { value: true },
            hpr_id: { value: hfrAbhaId },
          },
      userDataPatch: isAbhaFlow
        ? {
            fName: { '#required': false, '#isDisabled': true },
            lName: { '#required': false, '#isDisabled': true },
          }
        : {
            fName: { '#required': false, '#isDisabled': true },
            lName: { '#required': false, '#isDisabled': true },
            hpr_id: { '#isDisabled': true },
          },
      shouldAlert: false,
    };
  }

  return {
    formStatePatch: {
      user_status: { value: false },
      hpr_id: { value: hfrAbhaId },
    },
    userDataPatch: null,
    shouldAlert: !isAbhaFlow,
  };
};
